import React from "react";
import { Card, CardBody, Badge } from "reactstrap";
import { stageOf, formatUserName } from "../helpers";

const DragCardPreview = ({ hit, steps }) => {
  const st    = stageOf(hit._source.applicant.enrollment, steps);
  const label = st ? st.aasm_state : "aceptado";
  const clr   = { pending:"secondary", editable:"info", approved:"success", rejected:"danger", aceptado:"secondary" }[label];
  const displayName = formatUserName(hit._source.applicant.user);

  return (
    <Card className="kanban-card shadow-lg" style={{ pointerEvents:"none" }}>
      <CardBody className="p-3">
        <div className="fw-bold small mb-1">{displayName}</div>
        <div className="small text-muted">{hit._source.applicant.user.email}</div>
        <Badge color={clr} pill className="mt-2">{label}</Badge>
      </CardBody>
    </Card>
  );
};

export default React.memo(DragCardPreview);
